import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {GLOBAL} from "common-shared";

@Component({
  selector: 'app-spec-line-visibility-display',
  templateUrl: './spec-line-visibility-display.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SpecLineVisibilityDisplayComponent implements OnInit {
  @Input() visibilityClv: string;
  visibilityClasses = GLOBAL.Classificators.Mandatory;

  constructor() { }

  ngOnInit(): void {
  }

}
